import React from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { signIn } from '../../actions/sessionActions';
import { setError } from "../../store/sessionSlice";

import { Button, Form, Input, Card, Layout } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import AlertBlock from "../../componets/AlertBlock";
import './style.scss';

type FORM_PARAMS = {
  username: string;
  password: string;
}

export default function Login() {
  const dispatch = useAppDispatch();
  const { error } = useAppSelector(state => state.session);

  function onFinish({ username, password }: FORM_PARAMS) {
    dispatch(signIn({ username, password }));
  }

  function onCloseError() {
    dispatch(setError(null));
  }

  return (
    <Layout className="login-wrapper" style={{ minHeight: "100vh" }}>
      <Card className="login-card">
        <h4 className="login-head">Please sign in to continue</h4>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Username"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="Password"
            />
          </Form.Item>

          <Form.Item>
            <Button className="login-button" type="primary" htmlType="submit">
              LOGIN
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Layout>
  );
}
